import styles from "./DebtDisclosureOnCloseWarningModal.module.css";
import StyledButton from "../common/buttons/StyledButton";
import BaseModal from "../common/modals/BaseModal/BaseModal";
import warningIcon from "../../assets/warning-icon.svg";

const strings = {
  mustClickSubmitModal: "Must Click Submit Modal",
  warningCode: "Error A_0384",
  mustClickSubmit:
    "You must select YES or NO for Debt Disclosure, then Click Submit",
  ok: "OK",
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

export default function DebtDisclosureOnCloseWarningModal(props: Props) {
  return (
    <BaseModal
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      label={strings.mustClickSubmitModal}
      className={styles.container}
    >
      <img src={warningIcon} alt="" />
      <div className={styles.codeText}>{strings.warningCode}</div>
      <div className={styles.warningText}>{strings.mustClickSubmit}</div>
      <StyledButton className={styles.button} onClick={props.onRequestClose}>
        {strings.ok}
      </StyledButton>
    </BaseModal>
  );
}
